import React from 'react';
import { Badge } from '../ui/Badge';
import { ORDER_ALTERNATIVES, ORDER_FLOW, orderStateLabel } from '../../types/marketplace';
import type { MarketplaceOrder, OrderState } from '../../types/marketplace';
export function orderTone(state: OrderState): 'ok' | 'brand' | 'warn' | 'danger' | 'neutral' {
  if (state === 'RELEASED' || state === 'COMPLETED') return 'ok';
  if (state === 'DISPUTED') return 'danger';
  if (state === 'CANCELLED' || state === 'EXPIRED' || state === 'REFUNDED' || state === 'PARTIALLY_REFUNDED') {
    return 'warn';
  }
  if (state === 'REQUESTED') return 'neutral';
  return 'brand';
}
export function OrderStateBadge({
  state
}: {
  state: OrderState;
}) {
  return <Badge tone={orderTone(state)} data-id="element-3074" data-mp="84hq2dzdb5bi">{orderStateLabel(state)}</Badge>;
}
export function OrderStateTrack({
  order
}: {
  order: MarketplaceOrder;
}) {
  const isAlternative = ORDER_ALTERNATIVES.includes(order.state);
  const currentIndex = ORDER_FLOW.indexOf(order.state);
  const reachedIndex = isAlternative ? Math.max(...order.history.map(entry => ORDER_FLOW.indexOf(entry.state)).filter(index => index >= 0), 0) : currentIndex;
  return <div data-id="element-3075" data-mp="h3mq4gfpqjd0">
      <ol className="flex flex-wrap items-center gap-x-1.5 gap-y-2" data-id="element-3076" data-mp="h1s5724fyr8x">
        {ORDER_FLOW.map((state, index) => {
        const reached = index <= reachedIndex;
        const current = !isAlternative && index === currentIndex;
        return <li key={state} className="flex items-center gap-1.5" data-id="element-3077" data-mp="77061tv7nwc1" data-mpi={index}>
              <span className={`rounded-md px-2 py-1 text-[11px] font-medium ${current ? 'bg-brand-700 text-white' : reached ? 'bg-brand-50 text-brand-800' : 'bg-canvas text-ink-subtle'}`} data-id="element-3078" data-mp="c5beq19rs0so">
                {orderStateLabel(state)}
              </span>
              {index < ORDER_FLOW.length - 1 && <span aria-hidden="true" className="text-[11px] text-line-strong" data-id="element-3079" data-mp="1v2xxjuca8ce8">
                  ›
                </span>}
            </li>;
      })}
      </ol>
      {isAlternative && <p className="mt-2.5 text-[12px] leading-5 text-ink-muted" data-id="element-3080" data-mp="1m0yih7ktvidx">
          This order left the standard flow at{' '}
          <span className="font-medium text-ink" data-id="element-3081" data-mp="1h3yi9dant9uq">{orderStateLabel(order.state)}</span>. Funds stay in
          escrow until the outcome is decided — nothing is released to the counterparty automatically.
        </p>}
      <ol className="mt-3 space-y-1 border-t border-line pt-3" data-id="element-3082" data-mp="29tf9w8qggmpw">
        {order.history.map(entry => <li key={`${entry.state}-${entry.at}`} className="cz-num flex justify-between text-[12px]" data-id="element-3083" data-mp="24y9e8i793tom">
            <span className="text-ink-muted" data-id="element-3084" data-mp="1zzonrahswodd">{orderStateLabel(entry.state)}</span>
            <span className="text-ink-subtle" data-id="element-3085" data-mp="2xi7z7mcknwbj">{entry.at}</span>
          </li>)}
      </ol>
    </div>;
}